import {
  BottomSheetBody,
  BottomSheetFooter,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  Flex,
  Input,
  Item,
  ItemContent,
  ItemSide,
  ItemTitle,
  Separator,
  SkeletonBlock,
  TextBody,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { Button } from "../../../../../components/Button"

type TransferFlowFormSkeletonProps = {
  count: number
}

export function TransferFlowFormSkeleton({
  count,
}: TransferFlowFormSkeletonProps) {
  const t = useTranslations("wallet.TransferFlowForm")
  return (
    <>
      <BottomSheetHeader className="justify-between">
        <BottomSheetHeaderTitle>{t("title", { count })}</BottomSheetHeaderTitle>
      </BottomSheetHeader>
      <BottomSheetBody>
        <div className="grid grid-cols-2 items-center py-3.5">
          <TextBody weight="semibold">{t("sendToLabel")}</TextBody>
          <Input disabled placeholder={t("recipientAddressPlaceholder")} />
        </div>
        <Separator className="my-0.5" />
        {new Array(count).fill(0).map((_, i) => (
          <Item className="py-4" key={i} variant="unstyled">
            <SkeletonBlock className="order-1 size-10 shrink-0" />
            <ItemContent>
              <ItemTitle>
                <SkeletonBlock className="h-4 w-24" />
              </ItemTitle>
            </ItemContent>
            <ItemSide>
              <SkeletonBlock className="size-6 rounded" />
            </ItemSide>
          </Item>
        ))}
      </BottomSheetBody>
      <BottomSheetFooter>
        <Flex className="justify-end">
          <Button disabled>{t("reviewButton")}</Button>
        </Flex>
      </BottomSheetFooter>
    </>
  )
}
